const languages = [
"English",                       
"English (UK)",
"Arabic",                 
"Bengali",                    
"Bulgarian",                       
"Chinese",                   
"Croatian",                  
"Czech",                       
"Danish",                     
"Dutch"  ,                     
"Estonian",                      
"Finnish"  ,                     
"French"    ,                  
"Georgian"   ,                   
"German"      ,                
"Greek"        ,              
"Hebrew"        ,               
"Hindi"          ,             
"Hungarian"       ,              
"Indonesian"       ,              
"Italian"           ,       
"Japanese"           ,          
"Korean"              ,       
"Latvian"              ,     
"Lithuanian"            ,         
"Malay"                  ,     
"Maltese"                 ,      
"Norwegian"                ,       
"Polish"                    ,   
"Portuguese"                 ,      
"Romanian"                    ,   
"Russian"                      , 
"Serbian"                       ,
"Slovak"                       ,
"Slovenian"                     ,  
"Spanish"                       ,
"Swedish"                       ,
"Tamil"                       ,
"Thai"                       ,
"Turkish"                     ,  
"Ukrainian"                    ,   
"Vietnamese"                    ,   
]
export default languages;